import React, { useEffect, useMemo } from "react";
import { ReactComponent as TimeIcon } from "../../assets/icons/time.svg";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import BaseInput from "../BaseInput";
import BaseDivideLine from "../BaseDivideLine";
import { useLocation } from "react-router-dom";
import buildInviteLink from "../../utils/buildInviteLink";
import PersonalAccount from "../../store/PersonalAccount";
import useScrollToElement from "../../hooks/useScrollToElement";
import { useTranslation } from "react-i18next";
import { copyText2, copyText3 } from "../../utils/constants";
import BaseTextButton from "../BaseTextButton";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";
import "./style.scss";
import useMutateCopyData from "../../hooks/useMutateCopyData";
import ROUTES from "../../utils/routes";
import usePwaPopup from "../../hooks/usePwaPopup";
import { isPWA } from "../../utils/helpers";
import Game from "../../store/Game";
import BaseButton from "../BaseButton";

export default observer(function InvitePair({
  children,
  title,
  className,
  link,
  id,
  game,
  startGame,
}) {
  InvitePair.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    className: PropTypes.string,
    link: PropTypes.string,
    id: PropTypes.number,
    game: PropTypes.object,
    startGame: PropTypes.func.isRequired,
  };
  const { t } = useTranslation();
  const { scrollToElement } = useScrollToElement();
  const { openModal } = useModalActions();
  const location = useLocation();
  const isInvitePage = location.pathname === ROUTES.PAYMENT_INVITE_PAGE;
  const cls = ["invite"];
  if (className) cls.push(className);
  const inviteLink = buildInviteLink(link);
  const { openPwaModal } = usePwaPopup();

  // todo можно вынести в helpers функция повторяется в useMutateCopyData.js
  const onMutateCopyData = (e) => {
    e.clipboardData.setData(
      "text/plain",
      `${t(game.type === "DEMO" ? copyText3 : copyText2)}
${inviteLink}`
    );
    e.preventDefault();
  };

  useMutateCopyData(inviteLink, game.type === "DEMO" ? copyText3 : copyText2);
  const onLinkCopyHandle = (clickedId) => {
    if (!isPWA()) {
      openPwaModal(game.id, true);
    }
    if (id === clickedId) {
      document.addEventListener("copy", onMutateCopyData);
    }
    if (PersonalAccount.timerLinksMap.length) {
      const prevTimer = PersonalAccount.timerLinksMap.shift();
      clearInterval(prevTimer);
    }
    // PersonalAccount.addTimer(
    //   setInterval(async () => {
    //     await PersonalAccount.getPersonalAccountData();
    //   }, 2000)
    // );
  };

  useEffect(() => {
    return () => {
      const prevTimer = PersonalAccount.timerLinksMap.shift();
      if (prevTimer) clearInterval(prevTimer);
      scrollToElement(`game-${game.id}`);
    };
  }, []);

  return (
    <div className={cls.join(" ")}>
      {!isInvitePage && <BaseDivideLine top={true} dash={true} />}
      <div className="invite__info">
        <div className="invite__info__title">
          <span>{title}</span>
          <TimeIcon className="invite__info__title__icon" />
        </div>
        <div className="invite__info__tip">
          <span>
            {game.type === "DEMO"
              ? t("personal_acc.invite_link_desc1_test")
              : t("personal_acc.invite_link_desc1")}
          </span>
          <br />
          <div>{children}</div>
        </div>
        <div className="invite__info__link">
          <BaseInput
            id={`input-clipboard-target-${id}`}
            className="invite__info__link__input"
            value={inviteLink}
            type="copy"
            copyOnClick={() => onLinkCopyHandle(id)}
          />
        </div>
      </div>
      <div className="invite__bottom">
        <div className="invite__play">
          {game.type === "PREMIUM" 
            ? <BaseButton
                loading={game.isLoading}
                onClick={() => startGame(game)}
                className="invite__play__btn"
                unfilled={Game.game?.id !== game.id}
              >
                {t("personal_acc.play")}
              </BaseButton>
            : <BaseButton
                loading={game.isLoading}
                onClick={() => startGame(game)}
                className="invite__play__btn"
                unfilled={Game.game?.id !== game.id}
              >
                {t("personal_acc.start_test")}
              </BaseButton>}
        </div>
        <div className="invite__remove-invite">
          <BaseTextButton
            iconStyle="icon-lines"
            className="remove-game-button"
            onClick={() => openModal(MODAL_TYPES.REMOVE_GAME, game.id)}
            icon="trash"
          >
            {t("personal_acc.remove_game")}
          </BaseTextButton>
        </div>
      </div>
    </div>
  );
});
